import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../api/authService";
import prcIdImage from "../assets/PRC_ID_image.jpg";
import ionasiaLogo from "../assets/ionAsia_logo_theme.jpg";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/ekyc");
        } catch (err) {
            setError(
                err.response?.data?.message || "Invalid email or password. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="portals-wrapper">
            <div className="brand-logo-topleft">
                <img src={ionasiaLogo} alt="I-OnAsia" />
            </div>
            <div className="portals-grid">

                <div className="portal-card qv-card">
                    <img
                        src={prcIdImage}
                        alt="ID verification illustration"
                        className="portal-image"
                    />
                    <h3> PRC ID Verification</h3>
                    <p className="portal-desc">
                        Verify a mainland China ID instantly via WeChat's secure facial
                        recognition and government-backed identity check.
                    </p>
                    <button
                        className="btn-primary portal-btn"
                        onClick={() => navigate("/quick-verification")}
                    >
                        Start Verification
                    </button>
                </div>

                <div className="portal-card">
                    <div className="portal-logo">IOA</div>
                    <h3>I-OnAsia Client Portal</h3>
                    <p className="portal-desc">
                        Sign in to view your eKYC verification status and reports.
                    </p>

                    <form onSubmit={handleSubmit} className="portal-form">
                        <div className="form-group">
                            <label>Email address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="you@company.com"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                            <div style={{ textAlign: "right", marginTop: 6 }}>
                                <Link to="/forgot-password" style={{ fontSize: 12, color: "#6b7280" }}>
                                    Forgot password?
                                </Link>
                            </div>
                        </div>

                        {error && <div className="form-error">{error}</div>}

                        <button type="submit" className="btn-primary portal-btn" disabled={loading}>
                            {loading ? "Signing in..." : "Sign in"}
                        </button>
                    </form>

                    <p style={{ textAlign: "center", fontSize: 13, marginTop: 16, color: "#6b7280" }}>
                        Don't have an account?{" "}
                        <Link to="/register" style={{ color: "#0b2545", fontWeight: 600 }}>
                            Register here
                        </Link>
                    </p>
                </div>

                <div className="portal-card admin-card">
                    <div className="portal-logo admin-logo">ADM</div>
                    <h3>I-OnAsia Admin Portal</h3>
                    <p className="portal-desc">
                        For I-OnAsia employees only. Manage cases, clients, and
                        compliance records.
                    </p>
                    <button
                        className="btn-primary portal-btn admin-btn"
                        onClick={() => window.location.href = "https://api.ionekyc.com/admin/login"}
                    >
                        Admin Sign In
                    </button>
                </div>

            </div>
        </div>
    );
}